export default "__VITE_ASSET__b6f6c2ef__"